import { motion } from "framer-motion";
import { ArrowUpRight, Zap } from "lucide-react";
import { scrollToId } from "@/data";

const EASE = [0.22, 1, 0.36, 1];

const TILES = [
  { label: "Louder Memes", target: "#shill-lab", hint: "Shill Lab" },
  { label: "Stronger Community", target: "#impact", hint: "Why It Hits" },
  { label: "A Narrative People Share", target: "#narrative", hint: "The Narrative" },
  { label: "Built Beyond One Cycle", target: "#terminal", hint: "Live Terminal" },
  { label: "Milestones & Giveaways", target: "#milestone-chart", hint: "Milestone Chart" },
  { label: "The Meme Vault", target: "#memes", hint: "Meme Gallery" },
];

export default function ApexNavigator() {
  return (
    <section id="apex" className="relative pt-24 sm:pt-28" data-testid="apex-navigator">
      <div className="mx-auto max-w-7xl px-4 sm:px-6">
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-60px" }}
          transition={{ duration: 0.8, ease: EASE }}
          className="relative overflow-hidden rounded-2xl border border-[rgba(229,169,60,0.5)] bg-gradient-to-br from-[#141720] to-[#0F1E36] p-8 sm:p-12"
        >
          <div className="pointer-events-none absolute -right-20 -top-20 h-64 w-64 rounded-full bg-[#E5A93C] opacity-10 blur-[80px]" />
          <div className="flex flex-wrap items-center gap-4">
            <Zap className="h-7 w-7 text-[#F6C85F]" />
            <h2 className="font-display text-2xl font-black uppercase tracking-tight text-[#F6C85F] sm:text-3xl">
              $TATE — The Apex Predator
            </h2>
          </div>
          <p className="mt-3 font-mono2 text-[11px] uppercase tracking-[0.25em] text-[#94A3B8]">
            Jump straight to what you're looking for
          </p>
          <div className="mt-8 grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
            {TILES.map((t, i) => (
              <button
                key={t.label}
                onClick={() => scrollToId(t.target)}
                data-testid={`apex-tile-${i + 1}`}
                className="group rounded-xl border border-[rgba(229,169,60,0.25)] bg-[#07080A]/60 px-5 py-4 text-left transition-all duration-300 hover:-translate-y-1 hover:border-[#F6C85F] hover:bg-[#07080A]"
              >
                <div className="flex items-center justify-between">
                  <p className="font-mono2 text-[10px] uppercase tracking-[0.25em] text-[#64748B] transition-colors group-hover:text-[#F6C85F]">
                    {t.hint}
                  </p>
                  <ArrowUpRight className="h-4 w-4 text-[#64748B] transition-all duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5 group-hover:text-[#F6C85F]" />
                </div>
                <p className="mt-1.5 font-display text-base font-bold text-[#F8FAFC]">{t.label}</p>
              </button>
            ))}
          </div>
        </motion.div>
      </div>
    </section>
  );
}
